module.exports = __webpack_public_path__ + "static/media/Screenshot3.de48d9e4.png";